import React, { Component } from 'react';
import { motion } from 'framer-motion';
export const Badge = ({
  children,
  color = 'cyan',
  className = ''
}: {
  children: React.ReactNode;
  color?: 'cyan' | 'verde' | 'amarillo' | 'gris';
  className?: string;
}) => {
  const colors = {
    cyan: 'bg-cyan/10 text-cyan border-cyan/30',
    verde: 'bg-verde/10 text-verde border-verde/30',
    amarillo: 'bg-amarillo/10 text-amarillo border-amarillo/30',
    gris: 'bg-gris-oscuro text-gris-claro border-gris-medio'
  };
  return <span className={`inline-block text-xs font-semibold px-3 py-1 rounded-full tracking-wider uppercase border ${colors[color]} ${className}`} data-id="element-316">
      {children}
    </span>;
};
export const Button = ({
  children,
  variant = 'primary',
  className = '',
  href,
  onClick
}: {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'nav';
  className?: string;
  href?: string;
  onClick?: () => void;
}) => {
  const baseStyle = 'inline-block text-center font-bold uppercase tracking-wide transition-all duration-200 cursor-pointer border-none';
  const variants = {
    primary: 'bg-cyan text-black text-[15px] md:text-[17px] py-4 px-8 md:px-11 rounded-xl hover:scale-[1.02] hover:shadow-[0_0_32px_rgba(0,229,255,0.3)]',
    secondary: 'bg-transparent text-cyan border-[1.5px] border-solid border-cyan text-[15px] py-4 px-8 rounded-xl hover:scale-[1.02]',
    nav: 'bg-cyan text-black text-[13px] py-2 px-5 rounded-lg hover:scale-[1.02]'
  };
  const Component = href ? motion.a : motion.button;
  return <Component href={href} onClick={onClick} className={`${baseStyle} ${variants[variant]} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-317">
      {children}
    </Component>;
};
export const CountdownTimer = ({
  hours,
  minutes,
  seconds,
  label = 'Lanzamiento termina en'
}: {
  hours: number;
  minutes: number;
  seconds: number;
  label?: string;
}) => {
  return <div className="inline-flex flex-col items-center gap-2 bg-cyan/5 border border-cyan/20 rounded-xl py-5 px-7 my-6" data-id="element-318">
      <p className="text-xs tracking-widest uppercase text-gris-claro" data-id="element-319">
        {label}
      </p>
      <div className="flex gap-3 items-center" data-id="element-320">
        <div className="text-center" data-id="element-321">
          <div className="text-4xl font-extrabold text-cyan leading-none" data-id="element-322">
            {String(hours).padStart(2, '0')}
          </div>
          <div className="text-[10px] text-gris-claro tracking-widest uppercase mt-1" data-id="element-323">
            Horas
          </div>
        </div>
        <div className="text-3xl font-extrabold text-cyan/50 leading-none pb-3" data-id="element-324">
          :
        </div>
        <div className="text-center" data-id="element-325">
          <div className="text-4xl font-extrabold text-cyan leading-none" data-id="element-326">
            {String(minutes).padStart(2, '0')}
          </div>
          <div className="text-[10px] text-gris-claro tracking-widest uppercase mt-1" data-id="element-327">
            Min
          </div>
        </div>
        <div className="text-3xl font-extrabold text-cyan/50 leading-none pb-3" data-id="element-328">
          :
        </div>
        <div className="text-center" data-id="element-329">
          <div className="text-4xl font-extrabold text-cyan leading-none" data-id="element-330">
            {String(seconds).padStart(2, '0')}
          </div>
          <div className="text-[10px] text-gris-claro tracking-widest uppercase mt-1" data-id="element-331">
            Seg
          </div>
        </div>
      </div>
    </div>;
};